import { scenarioApi } from '@mathflat/domain/Scenario'
import type { Scenario, SubScenario } from 'src/dto'

class ScenearioController {
  async fetchUserScenario() {
    const unitIds = await scenarioApi.getScenarioUnitIds({
      mp_event_name: 'T99-03_시나리오_유저_조회_API',
    })
    return new Set(unitIds)
  }

  async postScenario(id: Scenario['id'] | SubScenario['id']) {
    await scenarioApi.createScenarioActionLog(
      { unitId: id },
      { mp_event_name: 'T99-03_시나리오_유저_수행_API' },
    )
  }

  async fetchLastAssginedStudentId() {
    return scenarioApi.getScenarioLatestAssignedStudentId({
      mp_event_name: 'T99-03_시나리오_마지막_출제학생_API',
    })
  }

  async fetchLastScoredStudentId() {
    return scenarioApi.getScenarioLatestScoredStudentId({
      mp_event_name: 'T99-03_시나리오_마지막_채점학생_API',
    })
  }

  async unLikeSubScenario(id: SubScenario['id']) {
    await scenarioApi.deleteScenarioActionLog(
      { unitId: id },
      { mp_event_name: 'T99-03_시나리오_유저_수행취소_API' },
    )
  }
}

export const scenarioController = new ScenearioController()
